import { createContext, useContext } from 'react'
import type { DraggableAttributes, DraggableSyntheticListeners } from '@dnd-kit/core'

export type RowDragHandleProps = {
  attributes: DraggableAttributes
  listeners: DraggableSyntheticListeners | undefined
}

export const RowDragHandleContext = createContext<RowDragHandleProps | null>(
  null,
)

export const useRowDragHandle = () => useContext(RowDragHandleContext)
